<ubs-relation-list-container [listForm]="listForm" [parameters]="parameters" [title]="listContainerTitle" [addForm]="addForm" [appContext]="appContext" (selectedRow)="setSelectedRow($event)"></ubs-relation-list-container>
